export interface TreeItem {
  id: string;
  fromId?: string;
  name: string;
  updatedText?: string;
  tag?: string;
  originalTag?: string;
  children: TreeItem[];
  level: TreeLevel;
  expanded?: boolean;
  editing?: boolean;
  isDeleted?: boolean;
  isNew?: boolean;
  isUpdated?: boolean;
  propertiesUpdated?: boolean;
  updatedProperties?: any;
  updatedPosition?: number;
  parentComponentId?:string;
  isMoved?: boolean;
  position: number;
  hardPosition?: number;
  item: HRoute | HComponent | HElement | HSubComponent | HSubComponentElement | null;
}

export enum TreeType {
  Source = 'source',
  Target = 'target'
}

export enum TreeLevel {
  Route,
  Component,
  Element,
  SubComponent,
  SubComponentElement,
  Metadata = -1,
}

export interface RouteOverride {
  id: string;
  routeId: string,
  route: string,
  moved: boolean,
  position?: number,
  properties?: any,
  fromId?: string;
  added?: boolean,
  removed?: boolean,
}

export interface ComponentOverride {
  id: string;
  componentId: string;
  parentComponentId?: string;
  routeId?: string;
  fromId?:string;
  type: string;
  position: number;
  properties?: any;
  added?: boolean;
  removed?: boolean;
}

export interface ElementOverride {
  id: string;
  elementId: string;
  componentId: string;
  type?: string;
  position: number,
  isUpdated: boolean,
  fromId?: string,
  value?: string;
  updatedValue?: string;
  properties?: any;
  added?: boolean;
  removed?: boolean;
}

// export interface PropertiesOverride{
//   routeId?: string,
//   componentId?: string,
//   elementId?: string,
//   added?: boolean,
//   removed?: boolean,
//   key?: string,
//   value?: string
// }

enum RouteType {
  Video,
  Intro,
  IntroVideo,
  Videos,
  Feedback,
  Link,
  Quiz,
  Sometimes,
  Reminders,
  Actions,
  Reflection,
  Welcome,
  Read,
  RatingVideo,
  RatingAudio,
  RatingResults,
  Expand,
  Complete,
}

const RoutePathMap: Record<RouteType, string> = {
  [RouteType.Intro]: "/intro",
  [RouteType.IntroVideo]: "/intro-video",
  [RouteType.Video]: "/video",
  [RouteType.Videos]: "/videos",
  [RouteType.Read]: "/read",
  [RouteType.Welcome]: "/welcome",
  [RouteType.Expand]: "/expand",
  [RouteType.Sometimes]: "/sometimes",
  [RouteType.Reminders]: "/reminders",
  [RouteType.Actions]: "/actions",
  [RouteType.Link]: "/link",
  [RouteType.Quiz]: "/quiz",
  [RouteType.Reflection]: "/reflection",
  [RouteType.RatingVideo]: "/rating/video",
  [RouteType.RatingAudio]: "/rating/audio",
  [RouteType.RatingResults]: "/rating/results",
  [RouteType.Feedback]: "/feedback",
  [RouteType.Complete]: "/complete",
} as const;


type ValidRoutePath = (typeof RoutePathMap)[keyof typeof RoutePathMap];

export enum ComponentType {
  video,
  page,
  action,
  statement,
  'intro-video'
}

enum SubComponentType {
  'rating-component',
  'page'
}

enum ElementType {
  p,
  br,
  hr,
  'answer-item',
  'email-p',
  header,
  listitem,
  statement,
  likert,
  textarea,
  select,
  'yes-no',
  'next-button'
}

enum SubComponentElementType {
  p,
  br,
  hr,
}

export interface HSubComponentElement {
  elementId: string,
  type: SubComponentElementType,
  fromId: string,
  value: string,
  position: number,
  properties: Properties;
}

interface Properties {
  [key: string]: string;
}

export interface HElement {
  elementId: string,
  type: ElementType,
  fromId: string,
  value: string,
  position: number,
  properties: Properties;
}

export interface HSubComponent {
  componentId: string;
  parentComponentId: string;
  fromId: string,
  type: SubComponentType;
  elements: HSubComponentElement[];
  properties: Properties;
  position: number;
}

export interface HComponent {
  componentId: string;
  type: ComponentType;
  elements: HElement[];
  fromId: string,
  position: number;
  properties: Properties;
  subComponents?: HSubComponent[];
}

export interface HRoute {
  routeId: string;
  route: ValidRoutePath;
  fromId: string,
  position: number;
  components: HComponent[];
  properties: Properties;
}

export interface Overrides {
  routes: RouteOverride[];
  components: ComponentOverride[];
  elements: ElementOverride[];
  // properties: PropertiesOverride[];
}

export interface HContent {

  metadata: {
    properties: {
      version: number;
    }
  }
  overrides: Overrides;
  tree: TreeItem[];

  sections: HRoute[];
  positions: string[];
}
